import Scriba from 'react-scriba';

export class DataFluxPartenaire {

    static _onChargementFluxEiffage = () => {
        const url = "api/Liste/ListeFluxEiffage";
        const paramPost = Scriba.fetch().createParameterPost({});
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onChargementFluxPartenaire = () => {
        const url = "api/Liste/ListeFluxPartenaires";
        const paramPost = Scriba.fetch().createParameterPost({});
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onTelechargementDocument = (version, nomPartenaire, categorieDeDocuments, nomFichier) => {
        const objet = {
            version: version,
            nomPartenaire: nomPartenaire,
            categorieDeDocuments: categorieDeDocuments,
            nomFichier: nomFichier
        };
        const url = "api/Get/GetDocumentFluxPartenaire";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onTelechargementDocumentFluxEiffage = (nomFichier) => {
        const objet = { nomFichier: nomFichier };
        const url = "api/Get/GetDocumentFluxEiffage";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

}
